module.exports = __webpack_public_path__ + "media/images/meta/yogasix/favicon-9c07f8127829a35a589d7eabefdd89f2.png";